import React, { useEffect, useState } from "react"
import { isValidJSON, isValidPolygon } from "../../util/projectSettings"
// import { numberOfCoordinatesPairsEntered } from "../../util/projectSettings"
// import { isFirstEqualToLast } from "../../util/projectSettings"
import { isValidCoordinateString } from "../../util/projectSettings"
import { ApolloError } from "@apollo/client"
import { PendingSpinner } from "../Pending"
interface ProjectBoundryFormProp {
  formData: any
  setFormData: React.Dispatch<React.SetStateAction<any>>
  initialFormData: any
  t: any
  setWarning: React.Dispatch<React.SetStateAction<{ value: boolean; messssage: string }>>
  warning: { value: boolean; messssage: string }
  geoCooedinatesError?: ApolloError
  geoCoordinatesLoading?: boolean
}
export const ProjectBoundryForm = (props: ProjectBoundryFormProp) => {
  const { formData, setFormData, t, warning, setWarning, initialFormData, geoCooedinatesError, geoCoordinatesLoading } =
    props
  useEffect(() => {
    if (geoCooedinatesError) {
      setWarning({ value: true, messssage: geoCooedinatesError.message })
    }
  }, [geoCooedinatesError, setWarning])

  const handleChange = (e: any) => {
    const { value } = e.target
    console.log("%cvalue", "color:red", value)
    setFormData(value)
    if (value === "") {
      setWarning({
        value: true,
        messssage: t("connectSettings.warningMessages.emptyInput")
      })
    } else if (!isValidJSON(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.invalidJSON") })
    } else if (value === initialFormData) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.unChangedInput") })
    } else if (!isValidCoordinateString(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.default") })
    } else if (!isValidPolygon(value)) {
      setWarning({ value: true, messssage: t("connectSettings.warningMessages.notABoundary") })
    } else {
      setWarning({
        value: false,
        messssage: ""
      })
    }
  }

  return (
    <div>
      {warning.value && <Message message={warning.messssage} />}
      <div style={{ fontWeight: 600, marginBottom: "10px" }}>
        <label>{t("connectSettings.inputForm.label")}</label>
      </div>
      <div style={{ width: "100%", minHeight: "240px", display: "flex" }}>
        {geoCoordinatesLoading ? (
          <div className="w-100">
            <PendingSpinner />
          </div>
        ) : (
          <textarea
            placeholder={t("connectSettings.inputForm.placeholder")}
            value={formData}
            onChange={handleChange}
            rows={5}
            cols={50}
          />
        )}
      </div>
      <br />
    </div>
  )
}

export default ProjectBoundryForm

const Message = ({ message }: { message: string }) => {
  // Component to display warning message
  return (
    <div
      className="d-flex justify-content-between"
      style={{
        backgroundColor: "rgba(244, 209, 211, .5)",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "5px",
        fontSize: "16px",
        color: "#a51d25"
      }}
    >
      <p>{message}</p>
    </div>
  )
}
